import { render, staticRenderFns } from "./News1024.vue?vue&type=template&id=7a7fed2b&scoped=true"
import script from "./News1024.vue?vue&type=script&lang=js"
export * from "./News1024.vue?vue&type=script&lang=js"
import style0 from "./News1024.vue?vue&type=style&index=0&id=7a7fed2b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7fed2b",
  null
  
)

export default component.exports